import { render, staticRenderFns } from "./InfoCidadao.vue?vue&type=template&id=1fde946c&scoped=true"
import script from "./InfoCidadao.vue?vue&type=script&lang=js"
export * from "./InfoCidadao.vue?vue&type=script&lang=js"
import style0 from "./InfoCidadao.vue?vue&type=style&index=0&id=1fde946c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fde946c",
  null
  
)

export default component.exports